$(function(){

	(function(){
		$(window).on('load resize', function(){
			$('.choiceCurrent').each(function(){
				var _currentImg_H = $(this).find('img').outerHeight(true);
				$(this).css({'height': _currentImg_H });
			});
		});
	})();

	$('.packType').each(function(){
		var _this = $(this);
		var _type = _this.index()+1;

		_this.find('.choiceColor li').on('click', function(){
			_this.find('.choiceColor li').removeClass('current');
			$(this).addClass('current');

			var _index = $(this).index()+1;
			// 画像名を構築
			var imageName = 'surprisebox-packtype' + _type + '-color' + _index + '.png';
			
			// 現在表示されている画像のsrcを取得してベースURLを抽出
			var currentSrc = _this.find('.choiceCurrent img').attr('src');
			var baseUrl = '';
			
			if (currentSrc) {
				// 最後のスラッシュまでのパスを取得
				var lastSlash = currentSrc.lastIndexOf('/');
				if (lastSlash !== -1) {
					baseUrl = currentSrc.substring(0, lastSlash + 1);
				}
			}
			
			// 新しい画像URLを構築
			var imageUrl = baseUrl + imageName;
			
			// デバッグ用
			console.log('Color change:', {
				type: _type,
				index: _index,
				imageName: imageName,
				baseUrl: baseUrl,
				imageUrl: imageUrl
			});
			
			_this.find('.choiceCurrent').html('<img src="' + imageUrl + '" alt="">');
		});
	});

});
